import './App.scss';
import Main from './components/Main';
import Portfolio from './components/Portfolio';

function App() {
  return (
      <>
          <Main />
          <Portfolio />
      </>
  );
}

export default App;
